import { ParsedUrlQuery } from 'querystring';

type FilterParamsOptions<T extends ParsedUrlQuery> = {
  /**
   * The query params to filter.
   */
  query: ParsedUrlQuery;
  /**
   * The params to keep.
   */
  allowedParams: (keyof T)[];
  /**
   * The params that support multiple values.
   */
  arrayParams?: (keyof T)[];
  /**
   * Default params that will be overridden if they are present on `query`.
   */
  defaultParams?: Partial<T>;
};

/**
 * Filters `query` params to the subset specified in `allowedParams`.
 * Params that can have mulitple values should be specified in `arrayParams`
 * Default params can be passed as `defaultParams`
 */
const filterParams = <T extends ParsedUrlQuery>(
  options: FilterParamsOptions<T>,
): ParsedUrlQuery => {
  const {
    query,
    allowedParams,
    arrayParams = [],
    defaultParams = {},
  } = options;

  return allowedParams.reduce((params, key: string) => {
    if (query[key] != null && (key === 'filters' || query[key] !== '')) {
      // eslint-disable-next-line no-param-reassign
      params[key] = arrayParams.includes(key)
        ? [].concat(query[key])
        : query[key].toString();
    }
    return params;
  }, { ...defaultParams });
};

export default filterParams;
